import { ModalStatusTypes, SocialNetworksAvailables } from '@/interfaces/socialnetworks.interface'
import Category from '@interfaces/category.interface'
import { useCallback, useEffect } from 'react'
import ModalVinculateSocialNetwork from '../modal-vinculate-social-network/modal-vinculate-social-network'
import NewModalVinculateSocialNetwork from '../new-modal-vinculate-social-network/modal-vinculate-social-network'
import useGb from '@/hooks/use-gb/use-gb.hook'

const ModalVinculate = ({ state, setState, hasInfo, ...rest }) => {
  const gb = useGb()

  useEffect(() => {
    if (hasInfo) {
      history?.pushState(null, '', window?.location?.pathname)
    }
  }, [hasInfo])

  useEffect(() => {
    if (state?.user?.squidId) {
      gb?.setAttributes({
        id: state.user.squidId,
      })
    }
  }, [gb, state?.user?.squidId])

  const handleChange = useCallback(
    (field, value) => {
      if (state?.[field] !== value) {
        setState((prevState) => ({ ...prevState, [field]: value }))
      }
    },
    [setState, state]
  )

  return (
    <>
      {!gb?.isOn('new-modal-vinculate') ? (
        <ModalVinculateSocialNetwork
          key="modal-vinculate"
          openModalVinculate={state?.open}
          setOpenModalVinculate={(open: boolean) => handleChange('open', open)}
          modalStatus={state?.modalStatus}
          setModalStatus={(modalStatus: ModalStatusTypes) => handleChange('modalStatus', modalStatus)}
          selectedProfile={state?.selectedProfile}
          setSelectedProfile={(selectedProfile: string) => handleChange('selectedProfile', selectedProfile)}
          stepActive={state?.stepActive}
          loading={state?.loading}
          categories={state?.categories}
          setCategories={(categories: Category[]) => handleChange('categories', categories)}
          subCategories={state?.subCategories}
          setSubCategories={(subCategories: Category[]) => handleChange('subCategories', subCategories)}
          pages={state?.pages}
          socialNetwork={state?.socialNetwork}
          setSocialNetwork={(socialNetwork: SocialNetworksAvailables) => handleChange('socialNetwork', socialNetwork)}
          userToAddOnFinish={state?.userToAddOnFinish}
          newUser={state?.newUser}
          error={state?.error}
          setError={(error: Error) => handleChange('error', error)}
          {...rest}
        />
      ) : null}

      {gb?.isOn('new-modal-vinculate') ? (
        <NewModalVinculateSocialNetwork
          key="modal-vinculate"
          openModalVinculate={state?.open}
          setOpenModalVinculate={(open: boolean) => handleChange('open', open)}
          modalStatus={state?.modalStatus}
          setModalStatus={(modalStatus: ModalStatusTypes) => handleChange('modalStatus', modalStatus)}
          selectedProfile={state?.selectedProfile}
          setSelectedProfile={(selectedProfile: string) => handleChange('selectedProfile', selectedProfile)}
          stepActive={state?.stepActive}
          loading={state?.loading}
          categories={state?.categories}
          setCategories={(categories: Category[]) => handleChange('categories', categories)}
          subCategories={state?.subCategories}
          setSubCategories={(subCategories: Category[]) => handleChange('subCategories', subCategories)}
          pages={state?.pages}
          socialNetwork={state?.socialNetwork}
          setSocialNetwork={(socialNetwork: SocialNetworksAvailables) => handleChange('socialNetwork', socialNetwork)}
          userToAddOnFinish={state?.userToAddOnFinish}
          newUser={state?.newUser}
          error={state?.error}
          setError={(error: Error) => handleChange('error', error)}
          {...rest}
        />
      ) : null}
    </>
  )
}

export default ModalVinculate
